export function getDefaultConfirmParams() {
  return {
    code: '',
    password: '',
    passwordConfirm: '',
  };
}
